import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { CountriesCollection } from './countries.types';

export function countriesBackend(): Backend<CountriesCollection> {
  return {
    defaultOrder: {
      field: 'name',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'common/0.1/countries/',
      params: { extra_details: true },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
